{
    "RecordingList_Column_Description": "Description",
    "RecordingList_Column_Type": "Type",
    "RecordingList_Column_TelSys": "Telephony Server",
    "RecordingList_Column_Partition": "Partition",
    "RecordingList_Scope_All": "All",
    "RecordingList_Scope_ServiceWide": "Service wide",
    "RecordingList_Scope_SystemWide": "System wide",
    "RecordingList_Scope_Detached": "Detached",
    "RecordingList_Type_All": "All",
    "RecordingList_Type_Dubber": "Dubber",
    "RecordingList_Scope_Label": "Scope",
    "RecordingList_Type_Label": "Type",
    "NAME": "RecordingListLanguage"
}
